import { render, staticRenderFns } from "./singleSubjectAvg_tea_month_new2.vue?vue&type=template&id=63367711&scoped=true&"
import script from "./singleSubjectAvg_tea_month_new2.vue?vue&type=script&lang=js&"
export * from "./singleSubjectAvg_tea_month_new2.vue?vue&type=script&lang=js&"
import style0 from "./singleSubjectAvg_tea_month_new2.vue?vue&type=style&index=0&id=63367711&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63367711",
  null
  
)

export default component.exports